import React from 'react'
import Navbar from '../../Components/Navbar/Navbar'
import NewFooter from '../../Components/NewFooter/NewFooter'
import NewScholars from '../../Components/NewScholarship/NewScholars'
import { Footer } from '../../Components/Footer/Footer'

const Scholarship = () => {
  return (
    <>
        <Navbar />
        <NewScholars />
        <Footer />
    </>
  )
}

export default Scholarship